import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../hooks/useCart";

/**
 * Small "🛒 N" pill linking to /cart. Renders nothing when the cart is
 * empty so it doesn't clutter first-time visitors' view. Meant to sit
 * inside the shop pages' top action row.
 */
export default function CartPill({ className = "" }) {
  const { count } = useCart();
  if (count === 0) return null;
  return (
    <Link
      to="/cart"
      data-testid="cart-pill"
      className={`inline-flex items-center gap-1.5 rounded-full border border-black/15 bg-white px-3 py-1.5 font-display text-xs font-semibold text-[var(--brand-ink)] hover:border-[#0A0F17] ${className}`}
    >
      <ShoppingBag size={12} />
      Cart · {count}
    </Link>
  );
}
